import { evaluateFilterCriteria } from './filterCriteriaEvaluator';
import { populateApplicableActions } from './actionsManager';
import { handleSetActions } from './setActionsManager';
import { actionType, fieldType, operatorType, conditionType } from './enums';

function sortByProperty(property) {
  // eslint-disable-next-line func-names
  return function(a, b) {
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;

    return 0;
  };
}

function createFieldMap(fields) {
  const fieldIdValueMap = new Map();
  if (fields != null) {
    fields.forEach(field => {
      switch (field.fieldType) {
        case fieldType.Text:
          fieldIdValueMap.set(field.field_id, field.text_value);
          break;
        case fieldType.Numeric:
          fieldIdValueMap.set(field.field_id, field.numeric_value);
          break;
        case fieldType.ValuesList:
          fieldIdValueMap.set(field.field_id, field.values);
          break;
        case fieldType.Date:
          fieldIdValueMap.set(field.field_id, field.date_value);
          break;
        default:
          break;
      }
    });
  }
  return fieldIdValueMap;
}

function getRuleExecutionResult(rules, assessmentActions, fields, invokeFieldsDetailsObject, fvlFieldsValueMap) {
  const conditionFieldIdValueMap = createFieldMap(fields);
  const fieldIdsMap = new Map(
    fields.map(field => {
      return [field.field_id, field.id];
    })
  );

  const applicableRules = [];
  const setActionsMap = new Map();
  const filterActionsMap = new Map();
  let triggeredFieldId = null;

  if (invokeFieldsDetailsObject !== null)
    fieldIdsMap.forEach((value, key) => {
      if (value === invokeFieldsDetailsObject.fieldID) triggeredFieldId = key;
    });
  const sortedRules = rules.sort(sortByProperty('rule_order'));
  sortedRules.forEach(rule => {
    const ruleResult = evaluateFilterCriteria(rule, conditionFieldIdValueMap, operatorType, conditionType, fieldIdsMap, invokeFieldsDetailsObject);
    if (ruleResult) {
      const isRequiresContentChanged = rule.filter_conditions.some(fc => fc.requires_content_changed === true);
      applicableRules.push({ ruleId: rule.id, isRequiresContentChanged });
      const ruleActions = assessmentActions.filter(a => a.rule_id === rule.id);
      handleSetActions(
        rule,
        isRequiresContentChanged,
        ruleActions,
        triggeredFieldId,
        conditionFieldIdValueMap,
        setActionsMap,
        filterActionsMap,
        fvlFieldsValueMap
      );
    }
  });
  return { setActionsResult: Array.from(setActionsMap.values()), filterActionsResult: Array.from(filterActionsMap.values()), applicableRules };
}

function getApplicableActions(allActions, filterActionsResult, applicableRules) {
  let applicableActions = [];
  const applicableAcAclActions = allActions.filter(
    a => a.action_type === actionType.ApplyConditionalLayout && applicableRules.some(r => r.ruleId === a.rule_id && !r.isRequiresContentChanged)
  );
  applicableActions = applicableAcAclActions;
  filterActionsResult.forEach(filterAction => {
    applicableActions.push(filterAction);
  });

  return applicableActions;
}

export function rootActions(rules, actions, fields, invokeFieldsDetailsObject, fvlFieldsValueMap, criteriaFields) {
  const fieldCriteriaIds = criteriaFields;
  const executionResult = getRuleExecutionResult(rules, actions, fields, invokeFieldsDetailsObject, fvlFieldsValueMap);

  const setActions = [];
  const filterActions = executionResult.filterActionsResult;
  const applicableActions = getApplicableActions(actions, executionResult.filterActionsResult, executionResult.applicableRules);
  const assigneeFieldIds = filterActions.map(action => action.portal_field_id);

  executionResult.setActionsResult.forEach(action => {
    if (action.fieldType === fieldType.Date) {
      const sd = {
        portalFieldId: action.portalFieldId,
        set_date: action.value,
        fieldType: fieldType.Date
      };
      setActions.push(sd);
    } else if (action.fieldType === fieldType.ValuesList && action.onlyFiltered === false) {
      const select_values = [];
      if (action.value.length === 0) select_values.push(null);
      else action.value.forEach(v => select_values.push(v.value));

      const svl = {
        portalFieldId: action.portalFieldId,
        select_values,
        fieldType: fieldType.ValuesList
      };
      setActions.push(svl);
    }
  });
  const resultActions = populateApplicableActions(applicableActions, fieldCriteriaIds);
  return { resultActions, assigneeFieldIds, setActions };
}

export default {
  rootActions
};
